import { api } from '../api/client';

export function arrayBufferToBase64(buffer: ArrayBuffer) {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  bytes.forEach(byte => {
    binary += String.fromCharCode(byte);
  });
  return window.btoa(binary);
}

export async function fileToPdfMeta(file: File, extra: Record<string, unknown> = {}) {
  const buffer = await file.arrayBuffer();
  return {
    name: file.name,
    size: file.size,
    type: file.type || 'application/pdf',
    data_b64: arrayBufferToBase64(buffer),
    ...extra,
  };
}

async function fetchPdfBlobUrl(path: string) {
  let response;
  try {
    response = await api.get<Blob>(path, { responseType: 'blob' });
  } catch (error: any) {
    const data = error?.response?.data;
    if (data instanceof Blob) {
      const text = await data.text();
      try {
        const parsed = JSON.parse(text);
        throw new Error(parsed?.detail || 'PDF não encontrado.');
      } catch (parseError) {
        if (parseError instanceof Error && parseError.message !== text) throw parseError;
        throw new Error(text || 'PDF não encontrado.');
      }
    }
    throw error;
  }
  const contentType = response.headers['content-type'];
  const mediaType = typeof contentType === 'string' ? contentType : 'application/pdf';
  const blob = new Blob([response.data], { type: mediaType });
  return URL.createObjectURL(blob);
}

export async function openPdfFromApi(path: string, fallbackName = 'documento.pdf') {
  const url = await fetchPdfBlobUrl(path);
  const opened = window.open(url, '_blank', 'noopener,noreferrer');
  if (!opened) {
    const link = document.createElement('a');
    link.href = url;
    link.download = fallbackName;
    link.click();
  }
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

export async function downloadPdfFromApi(path: string, fileName = 'documento.pdf') {
  const url = await fetchPdfBlobUrl(path);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
